import React, { Component } from 'react';
// import microphone from './../imgs/microphone.svg';
// import stopIcon from './../imgs/stop.png';
// import pauseIcons from './../imgs/pause.png';
// import playIcons from './../imgs/play-button.png';
// import closeIcons from './../imgs/close.png';
import MicIcon from "@mui/icons-material/Mic";
import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";
import { LinearProgress } from "@material-ui/core";


import PauseCircleIcon from '@mui/icons-material/PauseCircle';
import StopCircleIcon from '@mui/icons-material/StopCircle';
// import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';

const audioType = 'audio/*';

class Recorder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      time: {},
      miliseconds: 0,
      recording: false,
      medianotFound: false,
      audios: [],
      audioBlob: null,
      stream: null
    };
    this.timer = 0;
    this.startTimer = this.startTimer.bind(this);
    this.countDown = this.countDown.bind(this);
    this.onClose = this.onClose.bind(this)
    this.stopRecording = this.stopRecording.bind(this)
  }

  handleAudioPause(e) {
    e.preventDefault();
    clearInterval(this.timer);
    this.mediaRecorder.pause();
    this.setState({ pauseRecord: true });
  }

  handleAudioStart(e) {
    e.preventDefault();
    this.startTimer();
    this.mediaRecorder.resume();
    this.setState({ pauseRecord: false });
  }

  startTimer() {
    // if (this.timer === 0 && this.state.seconds > 0) {
    this.timer = setInterval(this.countDown, 100);
    // }
  }

  countDown() {
    // Remove one second, set state so a re-render happens.
    if (this.props.limit) {
      if (this.state.time.m >= this.props.limit) {
        this.stopRecording()
        console.log(this.state.time, '******* hi timer');
      }
    }

    this.setState(prevState => {
      const miliseconds = prevState.miliseconds + 100;
      return ({ time: this.milisecondsToTime(miliseconds), miliseconds: miliseconds });
    });

    this.props.handleCountDown(this.state.time);
  }

  milisecondsToTime(milisecs) {

    let secs = milisecs / 1000;
    let hours = Math.floor(secs / (60 * 60));

    let divisor_for_minutes = secs % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);

    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);


    let obj = {
      h: hours,
      m: minutes,
      s: seconds,
      ms: milisecs
    };

    return obj;
  }

  async initRecorder() {
    navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
    if (navigator.mediaDevices) {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      if (this.props.mimeTypeToUseWhenRecording) {
        this.mediaRecorder = new MediaRecorder(stream, { mimeType: this.props.mimeTypeToUseWhenRecording });
      } else {
        this.mediaRecorder = new MediaRecorder(stream);
      }
      this.chunks = [];
      this.mediaRecorder.ondataavailable = e => {
        if (e.data && e.data.size > 0) {
          this.chunks.push(e.data);
        }
      };
      this.mediaRecorder.onstop = () => {
        this.saveAudio();
      };

      this.stream = stream;
    } else {
      this.setState({ medianotFound: true });
      console.log('Media Decives will work only with SSL.....');
    }
  }

  async startRecording(e) {
    e.preventDefault();
    // wipe old data chunks
    this.chunks = [];
    try {
      await this.initRecorder();
    } catch (error) {
      console.log(error);
      return;
    }
    // start recorder with 10ms buffer
    this.mediaRecorder.start(10);
    this.startTimer();
    // say that we're recording
    this.setState({ recording: true });
  }

  stopRecording(e) {
    clearInterval(this.timer);
    this.setState({ time: {} });
    if (e) {
      e.preventDefault();
    }
    // stop the recorder

    if (this.mediaRecorder && this.mediaRecorder.state !== "inactive") {
      this.mediaRecorder.stop();
    }

    if (this.stream && this.stream.getAudioTracks) {
      const tracks = this.stream.getAudioTracks();
      tracks.forEach((track) => {
        track.stop();
      });
    } else {
      console.log('No Tracks Found')
    }

    // say that we're not recording
    this.setState({ recording: false, pauseRecord: false, });
  }

  handleReset(e) {
    if (this.state.recording) {
      this.stopRecording(e);
    }
    this.setState({
      time: {},
      miliseconds: 0,
      recording: false,
      medianotFound: false,
      audios: [],
      audioBlob: null
    }, () => {

      this.props.handleReset(this.state);
    });

  }

  saveAudio() {
    // convert saved chunks to blob
    const blob = new Blob(this.chunks, { type: audioType });
    // generate video url from blob
    const audioURL = window.URL.createObjectURL(blob);
    // append videoURL to list of saved videos for rendering
    const audios = [audioURL];
    this.setState({ audios, audioBlob: blob });
    this.props.handleAudioStop({
      url: audioURL,
      blob: blob,
      chunks: this.chunks,
      duration: this.state.time
    });
  }

  onClose(e) {
    if (this.state.recording) {
      this.stopRecording(e);
    }
    this.props.onClose()
  }
  uploadFile() {
    console.log('kjhkjhkjkh');
    if (this.state.audioBlob) {
      this.props.handleAudioUpload(this.state.audioBlob)
    } else {
      console.log('chertopert');
    }

  }

  render() {
    const { recording, audios, time, medianotFound, pauseRecord } = this.state;
    const { showUIAudio, audioURL, disableFullUI } = this.props;

    if (disableFullUI) { return null; }
    return (
      <div className='recorder_library_box'>
        <div className="dialog-header">
          <div className="dialog-header-title">
            <div className="dialog-header-icon">
              <MicIcon sx={{ fontSize: "30px", margin: "0px" }} />
            </div>
            ضبط فایل صوتی
          </div>
          <IconButton
            onClick={this.onClose}
            color="error"
            sx={{
              aspectRatio: 1,
              width: "25px",
              height: "25px",
              backgroundColor: "rgb(250, 156, 156)",
            }}
            aria-label="delete"
          >
            <ClearIcon />
          </IconButton>
        </div>
        <div className='recorder_box'>
          <div className='recorder_box_inner'>
            {!medianotFound ?
              <div className='record_section'>
                <div className='audio_section'>
                  <span>{time.s !== undefined ? `${time.s <= 9 ? '0' + time.s : time.s}` : '00'} </span>
                  <span >:</span>
                  <span >{time.m !== undefined ? `${time.m <= 9 ? '0' + time.m : time.m}` : '00'}</span>
                </div>
                {!recording ?
                  <div className='audio_section' >برای ضبط کلیک کنید</div>
                  :
                  <div className='audio_section' >حداکثر ۳ دقیقه</div>
                }
                <div className='audio_section'>
                  {audioURL !== null && showUIAudio ?
                    <audio className='audio_player' controls>
                      <source src={audios[0]} type='audio/ogg' />
                      <source src={audios[0]} type='audio/mpeg' />
                    </audio>
                    :
                    <div className='btn_container' style={{ padding: 0 }}>
                      {!recording ?
                        audioURL == null &&
                        // <RadioButtonCheckedIcon fontSize='large' onClick={e => this.startRecording(e)} sx={{ color: '#f50057' }} />
                        <button className='button' onClick={e => this.startRecording(e)}>شروع ضبط</button>
                        :
                        <>
                          <button className='button' onClick={e => this.stopRecording(e)}>توقف ضبط</button>
                          {/* <StopCircleIcon fontSize='large' onClick={e => this.stopRecording(e)} sx={{ fontSize: 24 }} /> */}
                          {/* <button className='button' onClick={
                        !pauseRecord ?
                          e => this.handleAudioPause(e) :
                          e => this.handleAudioStart(e)
                      }>{pauseRecord ?'شروع': 'مکث'}</button> */}
                        </>
                      }
                    </div>
                  }
                </div>
                {this.props.uploading && (
                  <div>
                    <LinearProgress
                      variant="determinate"
                      value={this.props.uploadProcess}
                      color="primary"
                    />
                    <p style={{ textAlign: "center", marginTop: "10px" }}>
                      درحال بارگذاری...
                    </p>
                  </div>
                )}


                <div className='btn_container'>
                  <button disabled={this.props.uploading} onClick={() => this.uploadFile()} className='button'>
                    بارگذاری
                  </button>
                  {/* <button disabled={true} onClick={() => this.uploadFile()}>I am Disabled!</button> */}
                  <button onClick={(e) => this.handleReset(e)} className='button'>
                    دوباره
                  </button>
                </div>
              </div>
              :
              <div className='btn_container'>Seems the site is Non-SSL</div>
            }
          </div>
        </div>
      </div>
    );
  }
}

export default Recorder;

Recorder.defaultProps = {
  hideHeader: false,
  mimeTypeToUseWhenRecording: null,
  handleCountDown: (data) => { },
}